import React from 'react';
import classNames from 'classnames';
import { useSendProductToGoldenAppleStore } from '../../../../../hooks/useSendProductToGoldenAppleStore';
import Header from '../header/Header';
import Preview from '../preview/Preview';
import Footer from '../footer/Footer';
import useGetInfo from '../../model/hooks/useGetInfo';

const Product = React.forwardRef(function ({ className }, ref) {
  const productInfo = useGetInfo(arguments[0]);
  const extraInfoAndMethods = useSendProductToGoldenAppleStore({ ...arguments[0], ...productInfo });
  const fullInfo = { ...arguments[0], ...productInfo, ...extraInfoAndMethods };

  return (
    <div
      ref={ref}
      className={classNames('product', `product_${productInfo.status}`, className, {
        product_liked: fullInfo.hasFavourite,
        product_sold: fullInfo.hasBasket,
      })}
      onClick={extraInfoAndMethods.openCallback}
    >
      <Header {...fullInfo} />
      <Preview {...fullInfo} />
      <Footer {...fullInfo} />
    </div>
  );
});

export default Product;
Product.propTypes = {};
